import { type ReactNode } from 'react';
import clsx from 'clsx';

interface PanelProps {
  title: string;
  badge?: string;
  right?: ReactNode;
  children: ReactNode;
  className?: string;
}

export function Panel({ title, badge, right, children, className }: PanelProps) {
  return (
    <div className={clsx(
      'bg-panel-bg border border-panel-border rounded-[3px] flex flex-col overflow-hidden min-h-0',
      className,
    )}>
      <div className="flex items-center justify-between px-4 py-3 border-b border-panel-border shrink-0">
        <div className="flex items-center gap-2">
          <span className="text-xs font-mono font-semibold text-text-muted tracking-[1.4px] uppercase">
            {title}
          </span>
          {badge && (
            <span className="flex items-center gap-1 text-xs text-accent font-mono font-semibold">
              <span className="w-1 h-1 rounded-full bg-accent shadow-[0_0_6px_var(--color-accent),0_0_2px_var(--color-accent)] animate-pulse-status" />
              {badge}
            </span>
          )}
        </div>
        {right}
      </div>
      <div className="px-4 py-3.5 flex-1 flex flex-col overflow-hidden min-h-0">
        {children}
      </div>
    </div>
  );
}
